import { ThemeEnum } from '../enum/Theme';

export enum Platform {
  ANDROID = 'android',
  IOS = 'ios',
  WINDOWS = 'windows',
  MAC = 'mac',
  LINUX = 'linux',
  UNKNOWN = 'unknown',
}

export interface PlatformType {
  platform: Platform;
  theme: ThemeEnum;
}

export function getPlatform(): Platform {
  const userAgent = navigator.userAgent;

  const isIOS =
    /iPad|iPhone|iPod/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) return Platform.IOS;
  if (/Android/i.test(userAgent)) return Platform.ANDROID;
  if (/Win/i.test(userAgent)) return Platform.WINDOWS;
  if (/Mac/i.test(userAgent)) return Platform.MAC;
  if (/Linux/i.test(userAgent)) return Platform.LINUX;

  return Platform.UNKNOWN;
}

export function getThemeFromPlatform(themesByPlatform: PlatformType[]): ThemeEnum | null {
  const platform = getPlatform();
  const platformTheme = themesByPlatform.find((pt) => pt.platform === platform);

  if (platform === Platform.UNKNOWN) return null;

  return platformTheme ? platformTheme.theme : null;
}
